import { render } from "./Navbar.vue?vue&type=template&id=657d2e48"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=657d2e48&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\diafischchen-webpage\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__